import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loading from '@/components/loading/index.vue'
import * as fnandoCpf from '@fnando/cpf'
import moment from 'moment'

export default {
  components: {
    Loading
  },
  data () {
    return {
      rules: {
        cpf: (value) => fnandoCpf.isValid(value) || 'Insira um valor válido e tente novamente',
        name: (val) => val !== '' || 'Nome obrigatório',
        email: (v) => /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail precisa ser válido'
      },
      e1: true,
      name: null,
      phone: null,
      email: null,
      cpf: null,
      birthdate: null,
      isLoading: false,
      menuBirthDate: false,
      selectedStep: 0,
      questionnaireAnswered: false
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterSelectedQuiz'
    ]),
    validateCpf () {
      return this.cpf !== '' && fnandoCpf.isValid(this.cpf)
    },
    isNewQuiz () {
      return this.$route.params && (this.$route.params.id && this.$route.params.id === 'new')
    },
    options () {
      return {
        loading: this.isLoading
      }
    },
    questionsQuiz () {
      return this.getterSelectedQuiz.questions || []
    },
    disableFinallyQuizQuestions () {
      const listValues = this.questionsQuiz.filter((item) => item.value)
      const result = !(listValues && this.questionsQuiz && (listValues.length === this.questionsQuiz.length))

      return result && !this.questionnaireAnswered
    }
  },
  mounted () {
    this.setSelectedQuiz()
  },
  beforeDestroy () {
    this.SET_SELECT_QUIZ()
    this.SET_SELECT_QUIZ_BY_ID()
  },
  methods: {
    ...mapActions([
      'actionAddQuiz',
      'actionAddQuizAnswer',
      'actionGetQuizById'
    ]),
    ...mapMutations([
      'SET_SELECT_QUIZ',
      'SET_SELECT_QUIZ_BY_ID'
    ]),
    formatDateOfDatePicker (date) {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    onClickBackButton () {
      this.$router.push({ name: 'ListQuiz' })
    },
    setSelectedQuiz () {
      if (!this.isNewQuiz) {
        this.SET_SELECT_QUIZ_BY_ID(this.$route.params.id)

        this.getAllQuizAnswers()
      }
    },
    setStateQuestionnaireAnswered () {
      this.getAllQuizAnswers()

      this.questionnaireAnswered = true
    },
    managerSendOrShowQuestions () {
      if (!this.questionnaireAnswered) {
        this.addQuizAnswers()
      } else {
        this.onClickBackButton()
      }
    },
    getAllQuizAnswers (quiz = this.getterSelectedQuiz) {
      this.isLoading = true

      this.actionGetQuizById(quiz)
        .then(() => {
          this.isLoading = false

          this.cpf = this.getterSelectedQuiz.params.cpf || null
          this.name = this.getterSelectedQuiz.params.name || null
          this.email = this.getterSelectedQuiz.params.email || null
          this.phone = this.getterSelectedQuiz.params.phone || null
          this.birthdate = !this.getterSelectedQuiz.params.birth_date ? null : moment(this.getterSelectedQuiz.params.birth_date).format('DD/MM/YYYY')
        })
        .catch(() => {
          this.isLoading = false

          this.sendToast({
            text: 'Não foi possível buscar as respostas deste quiz, tente novamente mais tarde.',
            type: 'danger'
          })
        })
    },
    addQuizOrSeeAnswers () {
      if (this.isNewQuiz) {
        if (this.validateCpf) {
          const params = {
            parameters: {
              cpf: this.cpf,
              name: this.name,
              phone: this.phone,
              email: this.email,
              birth_date: this.birthdate
            },
            idClient: this.getterAccount.client.idClient
          }

          this.isLoading = true

          this.actionAddQuiz(params)
            .then((response) => {
              this.selectedStep = 2

              if (response) {
                if (response.questions && response.questions.length > 0) {
                  this.isLoading = false

                  this.sendToast({
                    text: 'Quiz criado com sucesso, agora você precisa respondê-lo.',
                    type: 'success'
                  })
                } else {
                  this.getAllQuizAnswers(response)

                  this.sendToast({
                    text: 'Ops, algo deu errado. Verifique o retorno do quiz!',
                    type: 'warning'
                  })
                }
              }
            })
            .catch((error) => {
              this.isLoading = false

              if (error && error.status) {
                this.sendToast({
                  text: this.treatmentMessageQuiz(error.status),
                  type: 'danger'
                })
              } else {
                this.sendToast({
                  text: 'Ocorreu um erro ao criar o quiz, tente novamente mais tarde.',
                  type: 'danger'
                })
              }
            })
        } else {
          this.sendToast({
            text: 'É necessário adicionar o CPF para enviar!',
            type: 'warning'
          })
        }
      } else {
        this.selectedStep = 2
      }
    },
    treatmentMessageQuiz (value) {
      return ({
        402: 'Você não possui crédito suficiente para continuar a criação do quiz!',
        400: 'Os parâmetros da requisição estão faltando!',
        412: 'Não foi possível criar o quiz por falta de dados cadastrais, por favor entre em contato com o suporte',
        422: 'Não há dados suficientes no banco para geração do quiz'
      }[value] || 'Ocorreu um erro desconhecido, tente novamente mais tarde!')
    },
    addQuizAnswers () {
      if (!this.disableFinallyQuizQuestions) {
        const params = {
          ticket_id: this.getterSelectedQuiz.ticket_id,
          parameters: this.questionsQuiz.map((item) => item.value) || []
        }

        this.isLoading = true

        this.actionAddQuizAnswer(params)
          .then(() => {
            this.setStateQuestionnaireAnswered()

            this.sendToast({
              text: 'Respostas enviadas com sucesso, você pode verificar o resultado na listagem de quiz.',
              type: 'success'
            })
          })
          .catch(() => {
            this.isLoading = false

            this.sendToast({
              text: 'Ocorreu um erro ao enviar as respostas, tente novamente mais tarde.',
              type: 'danger'
            })
          })
      } else {
        this.sendToast({
          text: 'Ops, você não preencheu as respostas corretamente!',
          type: 'warning'
        })
      }
    }
  }
}
